import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { isSameMonth } from 'date-fns'
import { setStoreCurrentMonthAction } from 'reducks/storeCalendar/actions'

const handleStoreCurrentMonth = (date: Date) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const currentMonth = getState().storeCalendar.currentMonth

    // 異なる月であれば更新
    if (!isSameMonth(currentMonth, date)) {
      dispatch(setStoreCurrentMonthAction(date))
    }
  }
}

export default handleStoreCurrentMonth
